import { TextLink } from '@circlefin/components'
import classNames from 'classnames'
import Trans from 'next-translate/Trans'

export interface RecaptchaDisclaimerProps {
  /**
   * Custom styling.
   */
  className?: string
}

export const RecaptchaDisclaimer: React.FC<RecaptchaDisclaimerProps> = ({
  className,
}) => {
  return (
    <p className={classNames('text-neutral-subtlest type-body-xs', className)}>
      <Trans
        components={[
          <TextLink.Link
            key={0}
            href="https://policies.google.com/privacy"
            rel="noopener noreferrer"
            size="xs"
            target="_blank"
            variant="primary"
          />,
          <TextLink.Link
            key={1}
            href="https://policies.google.com/terms"
            rel="noopener noreferrer"
            size="xs"
            target="_blank"
            variant="primary"
          />,
        ]}
        i18nKey="common:recaptcha.reCaptchaDisclaimer"
      />
    </p>
  )
}
